import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";

/* ---------------- TRANSACTION OPTIONS ---------------- */
const transactionOptions = [
  { value: "Regular", label: "Regular" },
  { value: "Project", label: "Project" },
  { value: "AHQ", label: "AHQ" },
];

const RecipeConsumption = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const location = useLocation();
  const [saving, setSaving] = useState(false);
  const centerCode = localStorage.getItem("code");
  const sewadarId = localStorage.getItem("sewadarId");
  const editId = location.state?.id || null;
  const isEditMode = !!editId;

  /* ---------------- STATE ---------------- */
  const [date, setDate] = useState("");
  const [transaction, setTransaction] = useState(null);

  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  const [recipeOptions, setRecipeOptions] = useState([]);
  const [selectedRecipe, setSelectedRecipe] = useState(null);

  const [recipeItems, setRecipeItems] = useState([]);
  const [availableQtyMap, setAvailableQtyMap] = useState({});

  const [persons, setPersons] = useState(0);
  const [producingQty, setProducingQty] = useState(0);

  const [basePersons, setBasePersons] = useState(1);
  const [baseProducingQty, setBaseProducingQty] = useState(1);
  const [hasPersons, setHasPersons] = useState(false);
const [hasProducingQty, setHasProducingQty] = useState(false);
const [producingUom, setProducingUom] = useState("");



  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH PROJECTS ---------------- */
  const fetchProjects = async () => {
    const res = await apiClient.get(`${SERVER_BASE}/area-projects`);
    setProjectOptions(
      res.data.map((p) => ({
        value: p.id,
        label: `${p.projectName} - [ ${p.projectCode} ]`,
      }))
    );
  };

  /* ---------------- FETCH RECIPES ---------------- */
  const fetchRecipeList = async () => {
    setLoading(true);
    const res = await apiClient.get(`${SERVER_BASE}/getRecipeList`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setRecipeOptions(
      (res.data || []).map((r) => ({
        value: r.id,
        label: `${r.producingItem} - ${r.department}`,
        raw: r,
      }))
    );
    setLoading(false);
  };

  /* ---------------- AVAILABLE QTY ---------------- */
  const getAvailableQty = async (itemId, department) => {
    const res = await apiClient.get(`${SERVER_BASE}/getAvailableQuantity`, {
      params: {
        item: itemId,
        location: `${department} : Store`,
        status: "As stock",
        department,
      },
    });
    return res.data?.availableQuantity || 0;
  };

  const recalculateConsumeQty = (newPersons, newProducingQty) => {
    const usePersons = Number(newPersons) > 0;
    const useProducingQty = Number(newProducingQty) > 0;

    const updated = recipeItems.map((item) => {
      let qty = item.baseQty;

      if (useProducingQty) {
        qty = (qty / baseProducingQty) * newProducingQty;
      }

      if (usePersons) {
        qty = qty * (newPersons / basePersons);
      }

      return {
        ...item,
        consumeQty: Number(qty.toFixed(3)),
      };
    });

    setRecipeItems(updated);
  };

  const handleRecipeChange = async (val) => {
    setSelectedRecipe(val);
    const recipe = val.raw;

    const rPersons = Number(recipe.persons || 0);
    const rProducingQty = Number(recipe.producingQty || 0);
    setHasPersons(rPersons > 0);
    setHasProducingQty(rProducingQty > 0);
    setPersons(rPersons);
    setProducingQty(rProducingQty);
    setBasePersons(rPersons || 1);
    setBaseProducingQty(rProducingQty || 1);
    setProducingUom(recipe.producingUom || "");


    let items = recipe.items || [];
    if (typeof items === "string") items = JSON.parse(items);

    const qtyMap = {};
    const rows = [];

    for (const i of items) {
      const available = await getAvailableQty(i.itemId, recipe.department);
      qtyMap[i.itemId] = available;

      rows.push({
        ...i,
        baseQty: Number(i.qty),
        consumeQty: Number(i.qty),
      });
    }

    setAvailableQtyMap(qtyMap);
    setRecipeItems(rows);
  };

  const fetchConsumptionById = async (id) => {
    const res = await apiClient.get(
      `${SERVER_BASE}/getRecipeConsumptionById/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  
    const d = res.data;
  
    setDate(d.date);
    setTransaction(transactionOptions.find((t) => t.value === d.transaction));
    setPersons(d.persons);
    setProducingQty(d.producingQty);
  
    // 🔴 FETCH ORIGINAL RECIPE
    const recipeRes = await apiClient.get(
      `${SERVER_BASE}/getRecipe/${d.recipeId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  
    const recipe = recipeRes.data;
    setHasPersons(Number(recipe.persons || 0) > 0);
    setHasProducingQty(Number(recipe.producingQty || 0) > 0);
    
    setBasePersons(Number(recipe.persons || 1));
    setBaseProducingQty(Number(recipe.producingQty || 1));
    setProducingUom(recipe.producingUom || "");
    /* ✅ FIND RECIPE OPTION FROM recipeOptions */
    const matchedOption = recipeOptions.find(
      (opt) => opt.value = recipe.id
    );
  
    if (matchedOption) {
      setSelectedRecipe(matchedOption);
    }
  
    let recipeItems = recipe.items;
    if (typeof recipeItems === "string") recipeItems = JSON.parse(recipeItems);
  
    const qtyMap = {};
    const rows = [];
  
    for (const rItem of recipeItems) {
      const savedItem = d.items.find(
        (i) => i.itemId === rItem.itemId
      );
  
      const available = await getAvailableQty(rItem.itemId, recipe.department);
      qtyMap[rItem.itemId] = available;
  
      rows.push({
        ...rItem,
        baseQty: Number(rItem.qty),          // ✅ ORIGINAL BASE
        consumeQty: savedItem?.consumeQty || 0,
      });
    }
  
    setAvailableQtyMap(qtyMap);
    setRecipeItems(rows);
  };

  const handleSubmit = async () => {
    if (saving) return; 
    setSaving(true);
  
    try {
      const validItems = recipeItems.filter((i) => i.consumeQty > 0);
  
      if (!date) {
         Swal.fire({
                      icon: "warning",
                      title: "Please select date",
                      toast: true,
                      timer: 3000,
                      position: "top-end",
                      showConfirmButton: false,
timerProgressBar:true
                    });
        setSaving(false);
        return;
      }
  
      if (!transaction) {
        Swal.fire({
          icon: "warning",
          title: "Please select transaction",
          toast: true,
          timer: 3000,
          position: "top-end",
          showConfirmButton: false,
          timerProgressBar:true
        });
        setSaving(false);
        return;
      }
  
      if (!selectedRecipe) {
        Swal.fire({
          icon: "warning",
          title: "Please select recipe",
          toast: true,
          timer: 3000,
          position: "top-end",
          showConfirmButton: false,
          timerProgressBar:true
        });
        setSaving(false);
        return;
      }
  
      if (recipeItems.length == 0) {
        Swal.fire({
          icon: "warning",
          title: "No recipe items found",
          toast: true,
          timer: 3000,
          position: "top-end",
          showConfirmButton: false,
          timerProgressBar:true
        });
        setSaving(false);
        return;
      }
  
      if (Number(persons) == 0 && Number(producingQty) == 0) {
        Swal.fire({
          icon: "warning",
          text: "Persons and Producing Qty both are zero. You cannot proceed with saving.",
          toast: true,
          timer: 3000,
          position: "top-end",
          showConfirmButton: false,
          timerProgressBar:true
        });
        setSaving(false);
        return;
      }
  
      for (const item of recipeItems) {
        const available = availableQtyMap[item.itemId] || 0;
        if (item.consumeQty > available) {
          Swal.fire({
            icon: "error",
            title: `Consume qty cannot exceed available qty for ${item.itemName}`,
            toast: true,
            position: "top-end",
            showConfirmButton: true,
          });
          setSaving(false);
          return;
        }
      }
  
      const payload = {
        date,
        transaction: transaction.value,
        projectId: selectedProject?.value || null,
        projectName: selectedProject?.label || null,
        recipeId: selectedRecipe.value,
        recipeName: selectedRecipe.label,
        department: selectedRecipe.raw.department,
        persons:persons,
        producingQty:producingQty,
        centerCode:centerCode,
        sewadarId:sewadarId,
        items: recipeItems.map((i) => ({
          itemId: i.itemId,
          itemName: i.itemName,
          consumeQty: i.consumeQty,
          uom: i.uom,
        })),
      };
  
      if (isEditMode) {
        await apiClient.put(
          `${SERVER_BASE}/updateRecipeConsumption/${editId}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await apiClient.post(
          `${SERVER_BASE}/saveRecipeConsumption`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
  
      Swal.fire({
        icon: "success",
        title: "Saved",
        toast: true,
        timer: 1500,
        position: "top-end",
        showConfirmButton: false,
      });
  
      navigate("../RecipeConsumptionList");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to save consumption", "error");
    } finally {
      setSaving(false); 
    }
  };
  
  useEffect(() => {
    fetchProjects();
    fetchRecipeList();
   
  }, []);
  useEffect(() => {
    if (editId) fetchConsumptionById(editId);
  }, [editId,recipeOptions]);

  return (
    <div className="formcontainer mt-5">
      <button
        className="btn btn-success mb-3"
        onClick={() => navigate("../RecipeConsumptionList")}
      >
        Back
      </button>

      <h4>Recipe Consumption</h4>

      <div className="row">
        <div className="col-md-3">
          <label>Date</label>
          <input
            type="date"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        <div className="col-md-3 ">
          <label>Transaction</label>
          <Select
            options={transactionOptions}
            value={transaction}
            onChange={setTransaction}
          />
        </div>
        {transaction?.value == "Project" && (
          <div className="col-md-3">
            <label >Project</label>
            <Select
              options={projectOptions}
              value={selectedProject}
              onChange={setSelectedProject}
              placeholder="Select Project"
            />
          </div>
        )}
        <div className="col-md-2">
          <label>Recipe</label>
          <Select
            options={recipeOptions}
            value={selectedRecipe}
            onChange={handleRecipeChange}
            isLoading={loading}
          />
        </div>
        
        {selectedRecipe && (
          <>
          {hasPersons && (
        <div className="col-md-2">
          <label>Persons</label>
          <input
            type="number"
            className="form-control"
            value={persons}
            onChange={(e) => {
              const val = Number(e.target.value);
              setPersons(val);
            
              // if producingQty is 0, derive it from BASE
              const newProducingQty =
                val > 0
                  ? (val / basePersons) * baseProducingQty
                  : 0;
            
              setProducingQty(Number(newProducingQty.toFixed(3)));
              recalculateConsumeQty(val, newProducingQty);
            }}
            
          />
        </div>
      )}
        {hasProducingQty && (
  <>
    <div className="col-md-2">
      <label>Producing Qty</label>
      <input
        type="number"
        className="form-control"
        value={producingQty}
        onChange={(e) => {
          const val = Number(e.target.value);
          setProducingQty(val);
        
          // if persons is 0, derive it from BASE
          const newPersons =
            val > 0
              ? (val / baseProducingQty) * basePersons
              : 0;
        
          setPersons(Number(newPersons.toFixed(0)));
          recalculateConsumeQty(newPersons, val);
        }}
        
      />
    </div>

    <div className="col-md-1">
      <label>UOM</label>
      <input
        type="text"
        className="form-control"
        value={producingUom}
        disabled
      />
    </div>
  </>
)}


        </>)}

     
      </div>

      {recipeItems.length > 0 && (
        <>
          <table className="table table-bordered table-sm mt-3">
            <thead>
              <tr>
                <th>Item</th>
                <th>Available</th>
                <th>Consume</th>
                <th>UOM</th>
              </tr>
            </thead>
            <tbody>
              {recipeItems.map((i, idx) => (
                <tr key={idx}>
                  <td>{i.itemName}</td>
                  <td>{availableQtyMap[i.itemId] || 0}</td>
                  <td>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={i.consumeQty}
                      onChange={(e) => {
                        const rows = [...recipeItems];
                        rows[idx].consumeQty = Number(e.target.value);
                        setRecipeItems(rows);
                      }}
                    />
                  </td>
                  <td>{i.uom}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="text-end">
          <button
  className="btn btn-success"
  onClick={handleSubmit}
  disabled={saving}
>
  {saving
    ? "Saving..."
    : isEditMode
    ? "Update"
    : "Save"}
</button>

          </div>
        </>
      )}
    </div>
  );
};

export default RecipeConsumption;
